import { getImage } from 'gatsby-plugin-image';

import { useGetGatsbyImages } from './get-image-from-gasby';

export const useGetImageByPath = (relativePaths: string[]) => {
  const data = useGetGatsbyImages();

  return relativePaths.map((imageRelativePath) =>
    getImage(data.allFile.nodes.find((node) => node.relativePath === imageRelativePath)),
  );
};
